
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ChatbotConfig } from '@shared/index';
import { BsModalService } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonModule } from 'primeng/button';

import { AdminService } from '@shared-angular/services/admin.service';
import { BotService } from 'src/app/shared/services/bot.service';
import { LoginService } from '@shared-angular/services/login.service';
import { ProjectService } from 'src/app/shared/services/project.service';
import { ProjectModalComponent } from '../../../ProjectModal/ProjectModal.component';
import { ProjectOverviewComponent } from "../../project-overview/project-overview.component";
import { ProjectBotsTabComponent } from "../project-bots-tab/project-bots-tab.component";

@Component({
  imports: [
    ProjectBotsTabComponent,
    ProjectOverviewComponent,
    ButtonModule,
    FormsModule,
    TooltipModule
],
  templateUrl: './home-page.component.html',
  styleUrl: './home-page.component.scss'
})
export class HomePageComponent {
  public allowedImportTypes: { suffix: string, mimetype: string }[] = [{ suffix: '.rai', mimetype: 'text/plain' }];
  public selectedImportFile: File | null = null;



  constructor(
    public projectService: ProjectService,
    private router: Router,
    private adminService: AdminService,
    private modalService: BsModalService,
    public loginServive: LoginService,
    public botService: BotService,
    private activatedRoute: ActivatedRoute
  ) {

  }



  // The active route determines this view. Bot resolvers update selectedProject
  // while this component is still visible, before the bot route is activated.
  public get isProjectPage(): boolean {
    return this.activatedRoute.snapshot.pathFromRoot.some(route => route.paramMap.has('projectid'));
  }

  public async deleteBot(id: string) {
    await this.adminService.deleteBot(id);
    this.projectService.bots = this.projectService.bots.filter(bot => bot._id !== id);
  }



  public testBotSheet(bot: ChatbotConfig) {
    const url = this.router.serializeUrl(this.router.createUrlTree(['/bot-sheet/' + bot._id]));
    window.open(url, '_blank');
  }

  /*
    public async onImportFileSelected(event: Event) {
      const element = event.target as HTMLInputElement;
      const fileList: FileList | null = element.files;
      if (fileList) {
        await this.onImportFileDropped(fileList);
      }
    } */


  public openAddProject() {
    const modalRef = this.modalService.show(ProjectModalComponent, { class: 'modal-lg' });

    modalRef.onHidden?.subscribe(async () => {
      await this.projectService.loadProjects();
    });
  }
}
